import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/index.css";
import App from "./App";
import { BrowserRouter } from "react-router";
import { AuthProvider } from "./providers/AuthProvider";
import { ThemeProvider } from "./providers/ThemeProvider";
import { Toaster } from "react-hot-toast";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <Toaster
            position="top-right"
            reverseOrder={true}
            toastOptions={{
              className: "toast",
              // Exceção deliberada à disciplina de estilo inline: react-hot-toast
              // injeta CSS-in-JS com fundo branco e texto escuro, e estilo inline
              // vence classe. Os valores continuam sendo tokens; a alternativa
              // seria !important no .toast, que o projeto evitou em toda parte.
              style: {
                background: "var(--bg-surface)",
                color: "var(--fg-strong)",
                border: "1px solid var(--border-default)",
              },
            }}
          />
          <App />
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  // </React.StrictMode>
);
